export default __webpack_public_path__ + "images/359ca00cf9cb92a95aedb40762384213.svg";